import React from "react";
import TopicCard from "../cards/display/TopicCard";
import { cardRegistry } from "../cards/cardRegistry";
import { useMessages } from "../hooks/useMessages";

const resolveCardComponent = (cardType, displayType) => {
  const card =
    cardRegistry[cardType][displayType] || cardRegistry.display["auto"];
  return card.component || TopicCard;
};

const CardFactory = React.forwardRef(
  (
    {
      card,
      topic,
      w,
      h,
      breakpoint,
      displayParameters = null,
      executeRequest,
      pipeline,
    },
    ref
  ) => {
    const { messages, loading, error } = useMessages(topic.id);

    if (loading || error || !messages) {
      return <div> ... </div>;
    }

    const lastMessage = messages[0];

    const display_type = card.subtype;
    const display_variant = card.variant;
    const display_parameters = card.params;

    if (!lastMessage && display_type === "auto") {
      return <TopicCard card={card} topic={topic} w={w} h={h} ref={ref} />;
    }

    const finalDisplayType =
      display_type === "auto" ? lastMessage.content_type : display_type;
    const finalDisplayVariant =
      display_variant === "auto" ? "default" : display_variant;

    const CardComponent = resolveCardComponent(card.type, finalDisplayType);

    if (messages) {
      return (
        <CardComponent
          card={card}
          topic={topic}
          messages={messages}
          w={w}
          h={h}
          breakpoint={breakpoint}
          displayVariant={finalDisplayVariant}
          displayParameters={
            displayParameters ? displayParameters : display_parameters
          }
          ref={ref}
          executeRequest={executeRequest}
          pipeline={pipeline}
        />
      );
    }
  }
);

export default CardFactory;
